<template>
  <a-row style="margin: 40px 0px 0px 0px">
    <a-col :span="14">
      <a-carousel
        v-if="housePicList.length"
        arrows
        dots-class="slick-dots slick-thumb"
        style="margin-bottom: 50px"
      >
        <a slot="customPaging" slot-scope="props">
          <img :src="getImgUrl(props.i)" />
        </a>

        <div v-for="(item, index) in housePicList" :key="index">
          <img :src="buildImgUrl(item)" />
        </div>
      </a-carousel>
      =
    </a-col>

    <a-col :span="10">
      <div class="price-block">
        <span class="price-label">出租底价</span>
        <span class="price-value">{{ floorPriceText }}</span>
        <span class="price-unit">{{ floorPriceUnitText }}</span>
      </div>

      <div class="status-wrap">
        <span class="status-tag">
          <span class="status-tag-text">公开招租</span>
        </span>
      </div>

      <div class="feature-tags">
        <span class="feature-tag">国企认证</span>
        <span class="feature-tag">信息公开透明</span>
        <span class="feature-tag">提前预约随时可看</span>
        <span v-if="showFloorPriceTip" class="feature-tag">
          出租底价仅向报名的意向承租方公开
        </span>
      </div>

      <div class="split-divider-wrap">
        <a-divider />
      </div>

      <div class="summary-grid">
        <div class="summary-item">
          <span class="summary-item-label">出租面积：</span>
          <span class="summary-item-value">{{ leaseAreaText }}</span>
        </div>

        <div class="summary-item">
          <span class="summary-item-label">租赁期限：</span>
          <span class="summary-item-value">{{ leaseTermText }}</span>
        </div>

        <div class="summary-item">
          <span class="summary-item-label">免租期限：</span>
          <span class="summary-item-value">{{ rentFreePeriodText }}</span>
        </div>
      </div>

      <div class="split-divider-wrap">
        <a-divider />
      </div>

      <div class="base-info-list">
        <div class="base-info-row">
          <span class="base-info-label">地址：</span>
          <span class="base-info-value">{{ addressText }}</span>
        </div>

        <div class="base-info-row">
          <span class="base-info-label">招租公告起始日期：</span>
          <span class="base-info-value">{{ disclosureStartDateText }}</span>
        </div>

        <div class="base-info-row">
          <span class="base-info-label">招租公告截止日期：</span>
          <span class="base-info-value">{{ disclosureEndDateText }}</span>
        </div>

        <div class="base-info-row">
          <span class="base-info-label">项目负责人：</span>
          <span class="base-info-value">盛思敏</span>
        </div>

        <div class="base-info-row">
          <span class="base-info-label">负责人联系电话：</span>
          <span class="base-info-value">
            <img src="@/assets/phone2.png" alt="" class="phone-icon" />
            57310808
          </span>
        </div>

        <div class="base-info-row" v-if="bidBaseInfo.hasPayBond == 1">
          <span class="base-info-label">保证金金额：</span>
          <span class="base-info-value">{{ bondAmountText }}</span>
        </div>

        <div class="base-info-row">
          <a
            class="platform-link"
            href="https://zlease.shexgrp.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            本项目需通过上海市交易集团不动产租赁平台进行统一报名（点击跳转）
          </a>
          <div class="platform-tip">
            注：已在本平台注册的用户可直接登录参与报名，无需重复注册。
          </div>
        </div>
      </div>
    </a-col>
  </a-row>
</template>

<script>
export default {
  name: "BidApplyTopInfo",

  props: {
    housePic: {
      type: Array,
      default: () => [],
    },
    bidBaseInfo: {
      type: Object,
      default: () => ({}),
    },
    houseBaseInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    housePicList() {
      return Array.isArray(this.housePic) ? this.housePic.filter(Boolean) : [];
    },

    floorPriceText() {
      const type = Number(this.bidBaseInfo.rentalPriceType);

      if (type === 1) {
        return this.formatMoney(this.bidBaseInfo.floorPrice);
      }

      if (type === 2) {
        const min = this.bidBaseInfo.rentalBasePriceRangeMin;
        const max = this.bidBaseInfo.rentalBasePriceRangeMax;

        if (!this.hasValue(min) && !this.hasValue(max)) {
          return "--";
        }

        if (this.hasValue(min) && this.hasValue(max)) {
          return `${this.formatMoney(min)} - ${this.formatMoney(max)}`;
        }

        if (this.hasValue(min)) {
          return `${this.formatMoney(min)} 起`;
        }

        return `${this.formatMoney(max)} 以内`;
      }

      return this.formatMoney(this.bidBaseInfo.floorPrice);
    },

    floorPriceUnitText() {
      const map = {
        1: "元/月",
        2: "元/年",
        3: "元/天/平方米",
        4: "元/月/平方米",
      };

      // 注意你字段说明里是 floorPriceeUnit，代码里之前是 floorPriceUnit
      return (
        map[
          this.bidBaseInfo.floorPriceeUnit || this.bidBaseInfo.floorPriceUnit
        ] || "元/年"
      );
    },

    leaseAreaText() {
      const value = this.houseBaseInfo.leaseArea;
      return this.hasValue(value) ? `${value} ㎡` : "--";
    },

    leaseTermText() {
      const value = this.bidBaseInfo.leaseTerm;
      const unit = this.bidBaseInfo.leaseTermUnit;

      if (!this.hasValue(value)) {
        return "--";
      }

      const map = {
        1: "个月",
        2: "年",
      };

      return `${value} ${map[unit] || ""}`;
    },

    rentFreePeriodText() {
      const value = this.bidBaseInfo.rentFreePeriod;
      const unit = this.bidBaseInfo.rentFreePeriodUnit;

      if (!this.hasValue(value)) {
        return "--";
      }

      const map = {
        1: "天",
        2: "个月",
      };

      return `${value} ${map[unit] || ""}`;
    },

    addressText() {
      return this.formatEmpty(this.houseBaseInfo.housingResAddress);
    },

    disclosureStartDateText() {
      return this.formatEmpty(
        this.bidBaseInfo.disclosureStartDate ||
          this.bidBaseInfo.disclosureStartTime ||
          this.bidBaseInfo.publicStartDate ||
          this.bidBaseInfo.noticeStartDate
      );
    },

    disclosureEndDateText() {
      return this.formatEmpty(
        this.bidBaseInfo.disclosureEndDate ||
          this.bidBaseInfo.disclosureEndTime ||
          this.bidBaseInfo.publicEndDate ||
          this.bidBaseInfo.noticeEndDate
      );
    },

    projectLeaderText() {
      return this.formatEmpty(
        this.bidBaseInfo.projectLeader ||
          this.bidBaseInfo.projectContact ||
          this.bidBaseInfo.contactPerson ||
          this.bidBaseInfo.contactName
      );
    },

    contactPhoneText() {
      return this.formatEmpty(
        this.bidBaseInfo.contactPhone ||
          this.bidBaseInfo.projectContactPhone ||
          this.bidBaseInfo.phone ||
          this.bidBaseInfo.contactTel
      );
    },

    bondAmountText() {
      const value = this.bidBaseInfo.bondAmount;
      return this.hasValue(value) ? `${value} 元` : "无需保证金";
    },

    showFloorPriceTip() {
      // 后续如果有“底价是否公开”字段，可以在这里调整
      // 例如：return this.bidBaseInfo.floorPriceOpenFlag !== 1
      return true;
    },
  },

  methods: {
    hasValue(value) {
      return value !== undefined && value !== null && value !== "";
    },

    formatEmpty(value) {
      return this.hasValue(value) ? value : "--";
    },

    buildImgUrl(url) {
      if (!url) {
        return "";
      }

      if (url.indexOf("?") > -1) {
        return url;
      }

      return `${url}?x-oss-process=image/resize,l_1000`;
    },

    getImgUrl(i) {
      return this.buildImgUrl(this.housePicList[i]);
    },

    formatMoney(value) {
      if (!this.hasValue(value)) {
        return "--";
      }

      const num = Number(value);

      if (Number.isNaN(num)) {
        return value;
      }

      return num.toLocaleString("zh-CN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style scoped>
/* For demo */
.ant-carousel >>> .slick-dots {
  height: auto;
}

.ant-carousel >>> .slick-slide img {
  border-radius: 12px;
  height: 500px;
  border: 5px solid #fff;
  display: block;
  margin: auto;
  max-width: 80%;
}

.ant-carousel >>> .slick-thumb {
  bottom: -45px;
}

.ant-carousel >>> .slick-thumb li {
  width: 60px;
  height: 45px;
}

.ant-carousel >>> .slick-thumb li img {
  border-radius: 3px;
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}

.ant-carousel >>> .slick-thumb li.slick-active img {
  filter: grayscale(0%);
}
</style>

<style lang="less" scoped>
.price-block {
  margin-bottom: 8px;
}

.price-label {
  font-weight: 700;
  font-size: 22px;
  font-family: Arial;
  color: #333333;
}

.price-value {
  margin-left: 8px;
  font-weight: 700;
  font-size: 28px;
  font-family: Arial;
  color: #ff0214;
}

.price-unit {
  margin-left: 4px;
  font-weight: 700;
  font-size: 24px;
  font-family: Arial;
  color: #ff0214;
}

.status-wrap {
  margin-top: 4px;
}

.status-tag {
  display: inline-block;
  background: linear-gradient(135deg, #e78215, #e4ae62);
  border-radius: 5px;
  line-height: 1;
}

.status-tag-text {
  font-weight: 500;
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #f7f7f7;
  margin: 4px 8px;
  display: inline-block;
}

.feature-tags {
  margin: 10px 0 0;
}

.feature-tag {
  background-color: #f1f5f8;
  color: #819aae;
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  margin: 4px 6px 4px 0;
}

.split-divider-wrap {
  width: 88%;
  margin-top: -10px;
}

.summary-grid {
  display: flex;
  flex-wrap: wrap;
}

.summary-item {
  width: 50%;
  margin-bottom: 12px;
}

.summary-item-label {
  font-size: 18px;
  color: #666666;
  font-family: Microsoft YaHei;
}

.summary-item-value {
  font-size: 20px;
  color: #3072f6;
  font-family: Microsoft YaHei;
  font-weight: 600;
}

.base-info-list {
  width: 100%;
}

.base-info-row {
  margin-bottom: 12px;
}

.base-info-label {
  font-size: 16px;
  color: #999999;
  font-family: Microsoft YaHei;
}

.base-info-value {
  font-size: 16px;
  color: #333333;
  font-family: Microsoft YaHei;
}

.phone-icon {
  height: 16px;
  vertical-align: middle;
  margin-right: 4px;
}

.platform-link {
  font-size: 16px;
  color: #0071fe;
  font-family: Microsoft YaHei;
}

.platform-tip {
  font-size: 12px;
  color: red;
  font-family: Microsoft YaHei;
  margin-top: 4px;
}
</style>